import { Injectable } from '@angular/core';
import { CapAlert } from './cap-alert.interface';
import { CapAlertType } from './cap-alert.enum';
import { BehaviorSubject } from 'rxjs';
import { CapAlertLevel } from './cap-alert-level.enum';

@Injectable()
export class CapAlertService {

  private alerts: CapAlert[] = [];
  private alertsSubject = new BehaviorSubject<CapAlert[]>([]);
  alerts$ = this.alertsSubject.asObservable();

  public success(message: string, alertLevel = CapAlertLevel.GLOBAL, delayed = false, dismiss = true, additionalInfoLink?: string) {
    this.add({ type: CapAlertType.SUCCESS, message, alertLevel, delayed, dismiss, additionalInfoLink });
  }

  public info(message: string, alertLevel = CapAlertLevel.GLOBAL, delayed = false, dismiss = true, additionalInfoLink?: string) {
    this.add({ type: CapAlertType.INFO, message, alertLevel, delayed, dismiss, additionalInfoLink });
  }

  public warning(message: string, alertLevel = CapAlertLevel.GLOBAL, delayed = false) {
    this.add({ type: CapAlertType.WARNING, message, alertLevel, delayed });
  }

  public danger(message: string, alertLevel = CapAlertLevel.GLOBAL, delayed = false, stack?: string) {
    this.add({ type: CapAlertType.DANGER, message, alertLevel, delayed, stack });
  }

  public dismiss(alert: CapAlert) {
    this.alerts = this.alerts.filter(a => a !== alert);
    this.informObserver();
  }

  public dismissAll(emit = true) {
    this.alerts = [];
    if (emit) {
      this.informObserver();
    }
  }

  public nextPage(): void {
    this.alerts = this.alerts.filter(alert => alert.delayed);
    this.alertsSubject.next(this.alerts);
    this.dismissAll(false);
  }

  private informObserver(): void {
    this.alertsSubject.next(this.alerts.filter(alert => !alert.delayed));
  }

  private add(alert: CapAlert): void {
    // avoid duplicates
    if (!this.alerts.some(a => a.message === alert.message)) {
      this.alerts.push(alert);
      if (alert.dismiss === true) {
        setTimeout(() => this.dismiss(alert), 5000);
      }
      if (!alert.delayed) {
        this.informObserver();
      }
    }
  }
}
